import React, { useContext, createContext, useState } from 'react'
import { useApolloClient } from '@apollo/client'
import { UPDATE_PAYMENT_HISTORIES } from 'query'

const PaymentHistoryContext = createContext(null)

const PaymentHistoryProvider = ({ children }) => {
  const apolloClient = useApolloClient()
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState('');

  const updatePaymentHistories = async (paymentHistories) => {
    setPaymentHistoryLoading('update-payment-histories');
    try {
      const result = await apolloClient.mutate({
        mutation: UPDATE_PAYMENT_HISTORIES,
        variables: {
          input: { paymentHistories },
        }
      });
      return result.data.updatePaymentHistories;
    } catch(err) {
      console.log("PaymentHistoryProvider updatePaymentHistories", err);
      throw err;
    } finally {
      setPaymentHistoryLoading('');
    }
  }

  return (
    <PaymentHistoryContext.Provider
      value={{
        paymentHistoryLoading,
        updatePaymentHistories
      }}
    >
      {children}
    </PaymentHistoryContext.Provider>
  )
}

const usePaymentHistory = () => {
  const context = useContext(PaymentHistoryContext)
  if (context == null) {
    throw new Error('usePaymentHistory() called outside of a PaymentHistoryProvider?')
  }
  return context
}

export { PaymentHistoryProvider, usePaymentHistory } 